const Descriptions_words  = {
    fr: {
        o_ADAD_HANNAH: {
            0: "Contrairement au portrait de groupe, le portrait individuel</br>représente une seule personne à la fois."
        },
        o_ANNIE_BAILLARGEON: {},
        o_CLAUDIE_GAGNON: {},
        o_HUA_JIN: {
            0: "Ensemble de deux</br>personnes.",
            4: "La Chine est un pays situé en Asie.</br>Sa capitale est Beijing.",
            10: "Ensemble des habitudes propres à un groupe</br>qui se transmettent au fil du temps."
        },
        o_JJ_LEVINE: {
            0: "Portrait de groupe rassemblant des membres</br>d’une même famille.",
            1: "Ensemble de trois</br>personnes."
        },
        o_JONAS_ST_MICHAEL: {},
        o_PATRICK_BERNATCHEZ: {},
        o_SKAWENNATI: {},
        o_MARISA_PORTOLESE: {},
        o_MORIDJA_KITENGE_BANZA: {
            0 : "Œuvre qu'une ou un artiste a réalisée</br>pour se représenter.",
            1 : "République démocratique du Congo.</br>Pays situé en Afrique centrale.",
            11 : "Aspects qui composent une personne</br>(âge, langue, culture, mode de vie, etc.)."
        },  
    },
    en: {
        o_ADAD_HANNAH: {
            0: "Unlike a group portrait, an individual portrait</br>shows just one person."
        },
        o_ANNIE_BAILLARGEON: {},
        o_CLAUDIE_GAGNON: {},
        o_HUA_JIN: {
            0: "Group of two</br>people.",
            4: "China is a country located in Asia.</br>Its capital is Beijing.",
            10: "Set of habits specific to a group</br>that are transmitted over time."
        },
        o_JJ_LEVINE: {
            0: "Group portrait composed of members</br>of a single family.",
            1: "Group of three</br>people." 
        },
        o_JONAS_ST_MICHAEL: {},
        o_PATRICK_BERNATCHEZ: {},
        o_SKAWENNATI: {},
        o_MARISA_PORTOLESE: {},
        o_MORIDJA_KITENGE_BANZA: {
            0 : "Type of work in which artists</br>portray themselves.",
            1 : "Democratic Republic of the Congo.</br>Country located in Central Africa.",
            11 : "Aspects that make up an individual</br>(age, gender, culture, lifestyle, etc.)."
        },  
    }
}

export { Descriptions_words }





// WEBPACK FOOTER //
// ./src/components/defis/js/Descriptions.js